<template>
  <div>
    <login-component
      @token="login($event)"
      v-if="!localStorage.token"
    ></login-component>

    <b-container fluid v-else>
      <b-button v-b-toggle.sidebar-1 class="float-left mt-n5"
        ><b-icon-justify></b-icon-justify
      ></b-button>
      <b-button @click="disconnect" class="float-right">Déconnexion</b-button>

      <div>
        <h4>THmes</h4>

        <b-tabs align="center">
          <b-tab title="Aides">
            <HelpsView />
          </b-tab>
          <b-tab title="Caractéristiques">
            <characteristics-management />
          </b-tab>
          <b-tab no-body title="Composants">
            <composants-component />
          </b-tab>
          <b-tab title="Vérifications" active>
            <verifications-table :isDisconnected="isDisconnected" />
          </b-tab>
          <b-tab title="Rapports">
            <reports-component />
          </b-tab>
          <b-tab title="Utilisateurs">
            <user-management />
          </b-tab>
        </b-tabs>
      </div>
    </b-container>
    <b-sidebar id="sidebar-1" visible title="" shadow backdrop>
      <div class="px-3 py-2">
        <b-button
          variant="info"
          block
          href="https://thaudits.jcloud-ver-jpe.ik-server.com"
          >THAudits</b-button
        >
        <b-button
          variant="info"
          block
          href="https://thaudits.jcloud-ver-jpe.ik-server.com?app=mapgisol"
          >MapGisol</b-button
        >
        <b-button variant="info" block>THmes</b-button>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import VerificationsTable from "./VerificationsTable.vue";
import UserManagement from "./UserManagement.vue";
import ReportsComponent from "./ReportsComponent.vue";
import LoginComponent from "./LoginComponent.vue";
import ComposantsComponent from "./ComposantsComponent.vue";
import CharacteristicsManagement from "./CharacteristicsManagement.vue";
import HelpsView from "./HelpsView.vue";


export default {
  components: {
    VerificationsTable,
    UserManagement,
    ReportsComponent,
    LoginComponent,
    ComposantsComponent,
    CharacteristicsManagement,
    HelpsView
  },
  data: function() {
    return {
      showUserManagement: false,
      showComponentsManagement: true,
      showCaracteristicsManagement: false,
      isDisconnected: false,
      showReportsComponent: false,
      showComposantsComponent: false,
      token: "",
      MapGisol: false,
      THAudits: true,
      THmes: false,
    };
  },
  watch: {
    token() {
      this.token = this.localStorage.token;
    },
  },
  mounted() {
    if (this.localStorage.token) {
      this.token = this.localStorage.token;
    }
  },
  methods: {
    disconnect() {
      this.localStorage.token = null;
      this.localStorage.user = null;
      this.token = null;
      this.isDisconnected = true;
    },
    login(token) {
      this.token = token;
    },
  },
};
</script>

<style>
.custom_navbar {
  margin-top: -60px;
}

/* .active {
  color: #ffffff !important;
} */

.round_corner {
  border-radius: 8px;
  /* margin: 20px; */
}
</style>
